import { AIModelChoices, type AIModelChoices as AIModelChoicesType, useApiEvidenceV1InternalRetrieve } from 'api';
import { AiFeedbackVisibilityProvider, EMPTY_HIDDEN_CATEGORIES, SegmentationOverlay } from 'features';
import { useTranslation } from 'i18n';
import { useParams } from 'react-router-dom';
import { Alert, Box, Page } from 'ui';

export const PhotoEvidenceView = () => {
  const { t } = useTranslation('orders');
  const { evidenceId } = useParams<{ evidenceId: string }>();
  const { data: evidence, isLoading } = useApiEvidenceV1InternalRetrieve(evidenceId ? Number(evidenceId) : 0, {
    query: { enabled: Boolean(evidenceId) },
  });

  const pageTitle = t('photoEvidenceView.pageTitle');

  if (!evidenceId) {
    return (
      <Page>
        <Alert severity="error">{t('photoEvidenceView.errors.evidenceIdRequired')}</Alert>
      </Page>
    );
  }

  if (isLoading) {
    return (
      <Page>
        <Page.Title title={pageTitle} />
        <Box sx={{ padding: 2, textAlign: 'center' }}>{t('photoEvidenceView.states.loading')}</Box>
      </Page>
    );
  }

  if (!evidence) {
    return (
      <Page>
        <Alert severity="error">{t('photoEvidenceView.errors.evidenceNotFound')}</Alert>
      </Page>
    );
  }

  const imageUrl = evidence.file_url;

  if (!imageUrl) {
    return (
      <Page>
        <Alert severity="warning">{t('photoEvidenceView.errors.noImageAvailable')}</Alert>
      </Page>
    );
  }

  const annotations = evidence.annotations || [];
  const model = (evidence.results?.model_name as AIModelChoicesType | undefined) ?? AIModelChoices.pet;

  return (
    <Page>
      <Page.Title title={pageTitle} />
      <Box sx={{ padding: 2 }}>
        <AiFeedbackVisibilityProvider>
          <SegmentationOverlay
            imageSrc={imageUrl}
            annotations={annotations}
            hiddenCategories={EMPTY_HIDDEN_CATEGORIES}
            model={model}
            showLegend={false}
            showFeedback={false}
            showAerosols={false}
            evidenceId={Number(evidenceId)}
          />
        </AiFeedbackVisibilityProvider>
      </Box>
    </Page>
  );
};
